import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SSTable from '../SSTable/SSTable';
import SSColumn from '../SSTable/SSColumn';
import ToolTipIcon from '../ToolTipIcon/ToolTipIcon';

export default class RolesTable extends Component {
  getName = role => {
    const {
      auth: {
        user: {
          user: { role_id },
        },
      },
    } = this.props;

    return (
      <div>
        <span>{role.name}</span>
        {+role_id === +role.role_id && <span className="text-light"> (my role)</span>}
      </div>
    );
  };

  getDescription = role => role.desc;

  getPermissions = role =>
    role.perm
      .split('|')
      .filter(item => item)
      .map((item, index) => (
        <span
          key={index}
          className=" inline-block mr-1 items-center justify-center text-center rounded-md bg-orange-50 px-2 py-1 text-xs font-medium text-sunrise inset-ring inset-ring-orange-600/20"
        >
          {item}
        </span>
      ));

  getUsers = role => {
    const { users } = this.props;

    return users.filter(item => +item.role_id === +role.role_id).length;
  };

  getEdit = role => (
    <div
      className="w-full bg-transparent h-full flex justify-center items-center"
      data-test="rolestable-edit"
    >
      <ToolTipIcon toolText="Edit Role">
        <Link to={`/roles/${role.role_id}`}>
          <img src="/assets/images/icons/edit.svg" alt="Edit" />
        </Link>
      </ToolTipIcon>
    </div>
  );

  render() {
    const { data, selected, onClick, onDoubleClick } = this.props;

    if (!data) {
      return null;
    }

    return (
      <SSTable
        className="responsive table-roles"
        data={data}
        rowHeight={50}
        rowsCount={data.length - 1}
        doubleClick={onDoubleClick}
        onSelect={onClick}
        selected={selected}
        selectable
        zebra
      >
        <SSColumn header="Role" cell={this.getName} />
        <SSColumn header="Description" cell={this.getDescription} />
        <SSColumn containerClasses="space-y-1" header="Permissions" cell={this.getPermissions} />
        <SSColumn center header="Users with this Role" cell={this.getUsers} />
        <SSColumn center width={5} header="Edit" cell={this.getEdit} />
      </SSTable>
    );
  }
}

RolesTable.propTypes = {
  data: PropTypes.array,
  auth: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  selected: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
};
